import { useEffect, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import UpIcon from "@mui/icons-material/ExpandLessRounded";
import DownIcon from "@mui/icons-material/ExpandMoreRounded";

import "./InputOptionComponent.css";

const InputOptionComponent = ({
  disabled,
  dynamicLabel = true,
  label,
  options,
  value,
  onSelect,
  height,
  width = "320px",
}) => {
  const [anchorMenu, setAnchorMenu] = useState(null);
  const [selectedOption, setSelectedOption] = useState(value);
  const isOptionOpen = Boolean(anchorMenu);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const openOption = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeOption = () => {
    setAnchorMenu(null);
  };

  const selectOption = (option) => {
    setAnchorMenu(null);
    setSelectedOption(option);
    onSelect(option);
  };

  return (
    <div className={`${height ? `h-[${height}]` : "h-10"} w-[${width}]`}>
      <Button
        className={`w-full ${disabled ? "!bg-[#EFF1F2]" : ""}`}
        sx={{ justifyContent: "space-between" }}
        color={isOptionOpen ? "primary" : "secondary"}
        disabled={disabled}
        endIcon={isOptionOpen ? <UpIcon /> : <DownIcon />}
        size='small'
        variant='outlined'
        onClick={openOption}
      >
        {dynamicLabel && selectedOption ? (
          selectedOption?.label
        ) : (
          <span className='text-[#B5BFC4]'>{label}</span>
        )}
      </Button>

      <Menu anchorEl={anchorMenu} open={isOptionOpen} onClose={closeOption}>
        {options?.map((option, idx) => (
          <MenuItem
            className={`input-option${
              selectedOption && selectedOption?.value === option.value
                ? " input-option-selected"
                : ""
            }`}
            key={`${option.label}-${option - value}-${idx}`}
            onClick={() => selectOption(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default InputOptionComponent;
